module.exports = __webpack_public_path__ + "static/media/google-play-badge.db9b21a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/google-play-badge.png
// module id = 64
// module chunks = 0